const LinearLoading = () => (
  <div className="progress" style={{ width: '100%', height: '10px' }}>
    <div
      className="progress-bar progress-bar-striped progress-bar-animated"
      style={{ width: '100%', height: '10px' }}
    />
  </div>
)

export default LinearLoading
